import { render, staticRenderFns } from "./HtLabel.vue?vue&type=template&id=070607a9&scoped=true&"
import script from "./HtLabel.vue?vue&type=script&lang=js&"
export * from "./HtLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070607a9",
  null
  
)

export default component.exports